import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "translation/useTranslation";
import { Button, Field, Input } from "components/ui";

export default function MissingMonthsReductionFactor({ register, handleSubmit, onSubmit }) {
  const dispatch = useDispatch();

  const { editableTranslate } = useTranslation();

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="col-md-12">
          <div className="form-row">
            <div className="form-group col-md-3">
              <Field label={editableTranslate('calculation.debugger.employee_missing_months')}>
                <Input type="number" number min={0} max={12} step={1} placeholder="0-12" {...register('employee_missing_months')} data-testid="employee-missing-months-input" />
              </Field>
            </div>
            <div className="form-group col-md-3">
              <Field label={editableTranslate('calculation.debugger.budget_number_of_total_months')}>
                <Input type="number" number min={0} max={12} step={1} placeholder="0-12" {...register('budget_number_of_total_months')} data-testid="budget-number-of-total-months-input" />
              </Field>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-md-6">
              <Button type="submit" variant="primary" data-testid="submit-button">Submit</Button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}